import ApiClient from '@/api/ApiClient';
import { SETTING_TYPE } from '@/typings/enums/SETTING_TYPE';

const client = new ApiClient('usersetting');

class UserSettingApi {
	static selectSetting (settingType: SETTING_TYPE) {
		return client.get<IUserSettingModel | undefined>(`?settingType=${settingType}`);
	}

	static updateSetting (updateUserSetting: Omit<IUpdateUserSettingModel, 'userId'>) {
		updateUserSetting.value = String(updateUserSetting.value);
		return client.put<void>('', updateUserSetting);
	}
}

export default UserSettingApi;
